import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchSurveyList, deleteSurvey } from "src/services/survey.service";
import { toast } from "sonner";

interface FetchSurveyListPayload {
  page: number;
  limit: number;
  search?: string;
}

export const doFetchSurveyList = createAsyncThunk(
  "survey/fetchSurveyList",
  async (payload: FetchSurveyListPayload) => {
    try {
      const response: any = await fetchSurveyList({
        page: payload.page,
        limit: payload.limit,
        search: payload.search,
      });

      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch surveys";
      throw errorMessage;
    }
  }
);


export const doDeleteSurvey = createAsyncThunk(
  "survey/deleteSurvey",
  async (id: number, { rejectWithValue }) => {
    try {
      const response: any = await deleteSurvey(id);

      toast.success(response.message || "Survey deleted");

      return { id, message: response.message };

    } catch (error: any) {
      const errorMsg = error.response?.data?.message || "Failed to delete survey";
      toast.error(errorMsg);
      return rejectWithValue(errorMsg);
    }
  }
);

